var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInfopanel = function SvgInfopanel(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 26 26"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 12h1v5h-1zM14 8h1v2h-1zM9 12H7v-2H6v2H4v1h2v2h1v-2h2z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 21h-10c-.8 0-1.5-.7-1.5-1.5V17h1v2.5c0 .3.2.5.5.5h10c.3 0 .5-.2.5-.5v-14c0-.3-.2-.5-.5-.5h-10c-.3 0-.5.2-.5.5V8H8V5.5C8 4.7 8.7 4 9.5 4h10c.8 0 1.5.7 1.5 1.5v14c0 .8-.7 1.5-1.5 1.5z"
  })));
};
export default SvgInfopanel;